<script>
import { EpisodeCardSmallElementMixin } from "%/dynamic-component-editor/standard-components/episode-card-small/episode-card-small-element-mixin";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";

export default {
  name: "EpisodeButton",
  elementPanelSettings: {
    displayName: "Go To Episode Button",
    elementGroup: "episode",
  },
  extends: BaseButtonElement,
  mixins: [EpisodeCardSmallElementMixin],
  methods: {
    handleButtonClick() {
      const showId = this.entity.showId;
      const seasonId = this.entity.seasonId;
      const episodeId = this.entity.id;

      window.location.href = `${this.links.web}/show/${showId}/season/${seasonId}/episode/${episodeId}`;
    },
  },
};
</script>
